<template>
	<div class="unknown-page-component">
		<h2>Neznámá subview komponenta <code v-if="componentName">{{ componentName}}</code></h2>
		<p>Toto subview nemá správné mapování v souboru <code>SubviewResolver.ts</code>.</p>
	</div>
</template>

<script setup lang="ts">
import {onMounted} from "vue";

const props = defineProps<{
	componentName: string;
}>();
onMounted(() => {
	console.log(props.componentName+" just mounted");
})
</script>

<style>
</style>